import { BehaviorSubject } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SettingsValueService {

  private instance = new BehaviorSubject<string | null>(null);
  public instance$ = this.instance.asObservable();

  private disableSaveButton = new BehaviorSubject<boolean>(false);
  public disableSaveButton$ = this.disableSaveButton.asObservable();

  public toggleEditing = new EventEmitter<string>();

  public get activeInstance(): string | null {
    return this.instance.value;
  }

  public set activeInstance(value) {
    this.instance.next(value);
  }

  public get disableSaveButtonValue(): boolean {
    return this.disableSaveButton.value;
  }

  public set disableSaveButtonValue(value: boolean) {
    this.disableSaveButton.next(value);
  }
}
